import { Contact } from "$/sections/contact";
import { Differentials } from "$/sections/differentials";
import { Features } from "$/sections/features";
import { Hero } from "$/sections/hero";
import { Pricing } from "$/sections/pricing";
import { Screenshots } from "$/sections/screenshots";
import { Testimonials } from "$/sections/testimonials";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <Differentials />
      <Screenshots />
      <Testimonials />
      <Pricing />
      <Contact />
    </>
  );
}
